<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-hidden-header' : targetScrollFlg},
    {'is-visible-menu':_state.visibleMenu}
    ]"
  >
  <BackgroundImage />
  

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="_state.visibleMenu"
      @closeMenu="_state.visibleMenu = false"
    />

    <!-- タグの編集 -->
    <transition name="popup">
      <SPTagEdit
        v-if="state.visibleTagEdit"
        @closeTagEdit="state.visibleTagEdit = false"
        @save="_state.isItemOpen = false"
      />
    </transition>

    <!-- タグ付けされているノート -->
    <transition name="popup">
      <SPTagSharedList
        v-if="state.visibleTagSharedList"
        @closeTagSharedList="state.visibleTagSharedList = false"
      />
    </transition>

    <!-- タグの削除 -->
    <transition name="popup">
      <SPTagDeleteConfirm
        v-if="state.visibleTagDeleteConfirm"
        @closeTagDeleteConfirm="state.visibleTagDeleteConfirm = false, _state.isItemOpen = false"
      />
    </transition>

    <div id="wrapper">

      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-2"
          @click="_state.visibleMenu = true"
        >
          <IconMenu class="icn" />
        </div>
      </div>

      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <SPButtonHistoryBack />
          <div class="header-title">
            <h1>タグの管理</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-heading">
            <div class="main-heading-row">
              <ul class="navi-list">
                <li class="navi-list-item"
                  :class="{'is-active': state.visibleTargetNumber === 0}"
                >
                  <button class="navi-list-item-label"
                    @click="state.visibleTargetNumber = 0"
                  >ノート</button>
                </li>
                <li class="navi-list-item"
                  :class="{'is-active': state.visibleTargetNumber === 1}"
                >
                  <button class="navi-list-item-label"
                    @click="state.visibleTargetNumber = 1"
                  >ブックマーク</button>
                </li>
                <li class="navi-list-item"
                  :class="{'is-active': state.visibleTargetNumber === 2}"
                >
                  <button class="navi-list-item-label"
                    @click="state.visibleTargetNumber = 2"
                  >検索条件</button>
                </li>
              </ul>
            </div>
          </div>
          <div class="main-container"
            @scroll="handleScroll"
            >
            <Carousel
              ref="carousel"
              :perPage="1"
              :speed="200"
              :minSwipeDistance="100"
              :navigateTo="state.visibleTargetNumber"
              :navigationEnabled="false"
              :paginationEnabled="false"
              @pageChange="action.onCarouselChange"
              :touchDrag="false"
              :mouseDrag="false"
            >
            <!-- ノート -->
            <Slide id="content-01">
              <p v-if="data.complete && data.countAll.note <= 0" class="ml20 mt20 txt">タグの登録がありません</p>
              <ul class="list-result list-result-small list-result-02">
                <li v-for="(list, dateIndex) in data.listsAll.note" :key="'date_list_note' + dateIndex" class="list-result-item"
                  :class="{'is-menu-visible': _state.isItemOpen}"
                >
                  <div class="list-result-item-main">
                    <div class="list-result-title mb0"
                      @click="action.sharedItem(list.id, list.name)"
                    >
                      <span class="list-result-title-main">{{list.name}}</span>
                      <span class="list-result-title-num">({{list.num}})</span>
                    </div>
                  </div>
                  <div class="list-result-item-sub">
                    <div class="button edit">
                      <button role="button" class="btn"
                        @click="action.editItem(list.id)"
                      >
                        編集
                      </button>
                    </div>
                    <div class="button delete" >
                      <button class="btn" type="button"
                        @click="action.deleteItem(list.id)"
                      >
                        <FontawesomeIcon :icon="['far', 'times']" class="icn" />
                      </button>
                    </div>
                  </div>
                  <button class="list-result-item-menu" @click="_state.isItemOpen = !_state.isItemOpen">
                    <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
                  </button>
                </li>
              </ul>
            </Slide>
            <!-- ブックマーク -->
            <Slide id="content-02">
              <p v-if="data.complete && data.countAll.bookmark <= 0" class="ml20 mt20 txt">タグの登録がありません</p>
              <ul class="list-result list-result-small list-result-02">
                <li v-for="(list, dateIndex) in data.listsAll.bookmark" :key="'date_list_bookmark' + dateIndex" class="list-result-item"
                  :class="{'is-menu-visible': _state.isItemOpen}"
                >
                  <div class="list-result-item-main">
                    <div class="list-result-title mb0"
                      @click="action.sharedItem(list.id, list.name)"
                    >
                      <span class="list-result-title-main">{{list.name}}</span>
                      <span class="list-result-title-num">({{list.num}})</span>
                    </div>
                  </div>
                  <div class="list-result-item-sub">
                    <div class="button edit">
                      <button role="button" class="btn"
                        @click="action.editItem(list.id)"
                      >
                        編集
                      </button>
                    </div>
                    <div class="button delete" >
                      <button class="btn" type="button"
                        @click="action.deleteItem(list.id)"
                      >
                        <FontawesomeIcon :icon="['far', 'times']" class="icn" />
                      </button>
                    </div>
                  </div>
                  <button class="list-result-item-menu" @click="_state.isItemOpen = !_state.isItemOpen">
                    <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
                  </button>
                </li>
              </ul>
            </Slide>
            <!-- 検索 -->
            <Slide id="content-03">
              <p v-if="data.complete && data.countAll.search <= 0" class="ml20 mt20 txt">タグの登録がありません</p>
              <ul class="list-result list-result-small list-result-02">
                <li v-for="(list, dateIndex) in data.listsAll.search" :key="'date_list_search' + dateIndex" class="list-result-item"
                  :class="{'is-menu-visible': _state.isItemOpen}"
                >
                  <div class="list-result-item-main">
                    <div class="list-result-title mb0"
                      @click="action.sharedItem(list.id, list.name)"
                    >
                      <span class="list-result-title-main">{{list.name}}</span>
                      <span class="list-result-title-num">({{list.num}})</span>
                    </div>
                  </div>
                  <div class="list-result-item-sub">
                    <div class="button edit">
                      <button role="button" class="btn"
                        @click="action.editItem(list.id)"
                      >
                        編集
                      </button>
                    </div>
                    <div class="button delete" >
                      <button class="btn" type="button"
                        @click="action.deleteItem(list.id)"
                      >
                        <FontawesomeIcon :icon="['far', 'times']" class="icn" />
                      </button>
                    </div>
                  </div>
                  <button class="list-result-item-menu" @click="_state.isItemOpen = !_state.isItemOpen">
                    <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
                  </button>
                </li>
              </ul>
            </Slide>
            </Carousel>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

import { Carousel, Slide } from 'vue-carousel'
import { TagList } from '@/logic/tag/TagList'

import SPMenu from '@/components/sp/popup/SPMenu.vue'
import SPTagEdit from '@/components/sp/popup/SPTagEdit.vue'
import SPTagSharedList from '@/components/sp/popup/SPTagSharedList.vue'
import SPTagDeleteConfirm from '@/components/sp/popup/SPTagDeleteConfirm.vue'

export default defineComponent({
  components: {
    SPMenu,
    SPTagEdit,
    SPTagSharedList,
    SPTagDeleteConfirm,
    Carousel,
    Slide
  },
  setup (props, context) {
    const _state = reactive({
      visibleMenu: false,
      isItemOpen: false
    })

    return {
      _state,
      ...TagList(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.main {
  &-heading-row {
    height: $sp-main-heading-height;
  }
  &-container {
    @include changeHeightOnScroll($sp-header-height + $sp-main-heading-height);
  }
  &-heading {
    position: relative;
    .navi-list {
      margin: 0 10px;
      overflow-x: auto;
      white-space: nowrap;
      &-item {
        display: inline-block;
        position: relative;
        &:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
          height: 2px;
          width: 100%;
          background-color: $color-yellow;
          opacity: 0;
          transition: all .2s ease;
        }
        &-label {
          display: block;
          font-size: 1.6rem;
          color: $color-sup;
          font-weight: bold;
          padding: 20px 10px;
        }
        &.is-active {
          &:after {
            opacity: 1;
          }
          .navi-list-item-label {
            color: $color-link;
          }
        }
      }
    }
    .navi-arrow {
      position: absolute;
      top: 50%;
      transform: translate3d(0,-55%,0);
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      .icn {
        color: $color-link;
      }
      &.next {
        right: 0;
        border-left: 1px solid $color-line;
      }
      &.prev {
        left: 0;
        border-right: 1px solid $color-line;
      }
    }
  }
}

.menu-btn {
  &-2 {
    border-top-left-radius: 8px;
  }
}

</style>
